export function Warnings({ messages }: { messages: string[] }) {
  if (messages.length === 0) return null;
  return (
    <section className="border border-slate-200 bg-slate-50 rounded-lg p-3 text-xs text-slate-600">
      <ul className="list-disc pl-4 space-y-0.5">
        {messages.map((m, i) => (
          <li key={i}>{m}</li>
        ))}
      </ul>
    </section>
  );
}
